<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <FiltersItem>
    <template #title>Dev</template>
    <template #content>
      <FiltersItemContent>
        <template #title>Transport Information</template>
        <template #content><FiltersList :items="results__response?.uniqueTransportInformation?.map(({plainText: text, code: value}) => ({text, value, isChecked: true})).sort(sortByProperty())" /></template>
      </FiltersItemContent>
      <FiltersItemContent>
        <template #title>Service Brand Names</template>
        <template #content><FiltersList :items="results__response?.uniqueServiceBrandNames?.map((item, index) => ({text: item, value: index, isChecked: true})).sort(sortByProperty())" /></template>
      </FiltersItemContent>
      <FiltersItemContent>
        <template #title>Booking classes</template>
        <template #content><FiltersList :items="results__response?.uniqueBookingClasses?.map(({rule: text, plainText: value}) => ({text, value, isChecked: true})).sort(sortByProperty())" /></template>
      </FiltersItemContent>
      <FiltersItemContent>
        <template #title>Product Codes</template>
        <template #content><FiltersList :items="results__response?.uniqueProductCodes?.map(({plainText: text, code: value}) => ({text, value, isChecked: true})).sort(sortByProperty())" /></template>
      </FiltersItemContent>
    </template>
  </FiltersItem>
</template>

<script setup>
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();


const results__response = computed(() => resultQueryStore.state.response.response);

function sortByProperty (key = 'text') {
	return (a, b) => a[key].localeCompare(b[key], 'sv');
}
</script>

<style lang="scss" scoped>

</style>
